import { select, put, takeLatest, all } from 'redux-saga/effects';
import { history } from '../store/store';
import axios from 'axios';
import { privateCall } from './api.saga';
import { notificationActions } from '../reducers/notification.reducer';

import { authActions } from '../reducers/auth.reducer';

function* signup({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.auth.signup);
		const { token, user, profile } = yield privateCall({ endpoint, payload });

		yield put(notificationActions.addToast({
			message: 'Thank you for signing up! Your account is good to go!',
			sticky: true,
		}));

		yield put(authActions.signupComplete({
			user,
			profile,
			token,
		}));
	} catch (e) {}
}

function* login({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.auth.login);
		const response = yield privateCall({ endpoint, payload });

		if (payload.rememberMe)
			localStorage.setItem('token', response.token);

		yield put(authActions.loginComplete(response));
	} catch (e) {}
}

function* getUser() {
	try {
		const endpoint = yield select(s => s.config.endpoints.auth.getUser);
		const { user } = yield privateCall({ endpoint });

		yield put(authActions.getUserComplete({ user }));
	} catch (e) {}
}

function* logout() {
	try {
		localStorage.clear();
		axios.defaults.headers['x-auth-token'] = null;
		history.push('/');

		yield put(authActions.logoutComplete());
	} catch (e) {}
}

function* resetPassword({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.auth.resetPassword);
		yield privateCall({ endpoint, method: 'post', payload });

		yield put(notificationActions.addToast({
			message: 'Your password have been reset. Please login to continue.',
			sticky: true,
		}));

		history.push('/');
	} catch (e) {}
}

function* forgotPassword({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.auth.forgotPassword);
		yield privateCall({ endpoint, method: 'post', payload });

		yield put(notificationActions.addToast({
			message: 'An email have been sent to you.',
			sticky: true,
		}));
	} catch (e) {}
}

export default function* authSaga() {
	yield all([
		yield takeLatest(authActions.signup, signup),
		yield takeLatest(authActions.getUser, getUser),
		yield takeLatest(authActions.login, login),
		yield takeLatest(authActions.logout, logout),
		yield takeLatest(authActions.resetPassword, resetPassword),
		yield takeLatest(authActions.forgotPassword, forgotPassword),
	]);
}
